import { createElement } from 'react';
import SchemaItem from './schemaItem';
const SchemaObject = (props) => {
    const { prefix, data, showEdit, model, open, index } = props;
    return (createElement("div", { className: "object-style" }, Object.keys(data.properties).map((name, i) => (createElement(SchemaItem, { key: i, data: data, name: name, prefix: prefix, showEdit: showEdit, model: model, open: open, index: index })))));
};
export default SchemaObject;
